import React from 'react'
import { useNavigate } from 'react-router-dom'
import { ErrorBoundary } from '../../../components/common/ErrorBoundary'
import { useAppTranslation } from '../../../hooks/useAppTranslation'
import { FindSociety } from '../../../components/find-society/FindSociety'
import { theme } from '../../../theme/theme'
import { BackButton } from '../../../components/common/BackButton'
import { useDocumentTitle } from '../../../hooks/useDocumentTitle'
import { reverseDocumentTitle } from '../../../navigation/reverseDocumentTitle'
import { i18nSocietyType } from '../../../i18n'
import { useCurrentSociety } from '../../../hooks/useCurrentSociety'

export const FindSocietyView = (): React.ReactNode => {
  const { translate } = useAppTranslation()
  const { society } = useCurrentSociety()
  useDocumentTitle(reverseDocumentTitle('find-society'))
  const navigate = useNavigate()

  const goBack = (): void => {
    navigate(-1)
  }

  return (
    <ErrorBoundary>
      <div className="h-full w-full p-6">
        <div className="flex items-center space-x-4">
          <BackButton onClick={goBack} />
          <p style={theme.textVariants.h2}>
            {translate('findSocietyView.title', {
              context: i18nSocietyType(society?.societyTypeDisplayName),
            })}
          </p>
        </div>
        <FindSociety />
      </div>
    </ErrorBoundary>
  )
}
